/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

window.Plus = window.Plus || {};

Plus.desktopNavigation = {

  init: function() {

    var self = this;

    self.desktopBreakpoint = 750;
    self.$navigation = $('.navigation');

    if(self.$navigation.length > 0) {

      self.attachWindowResizeEvent();

    }

  }, 

  attachWindowResizeEvent: function() {

    var self = this;

    $(window).on('resize', function() {
      // Overwrite default theme behaviour of adding padding to top of navigation
      if ($(window).width() >= self.desktopBreakpoint) {
        self.$navigation.css({ 'padding-top' : 0 })
      }
    });

  }

}

jQuery(function() {
  Plus.desktopNavigation.init();
});